// extracted by css-extract-rspack-plugin
export default {"container":"Bp5Iy","header":"F7dUx","loadingContainer":"Peiqs","loadingContent":"D8OpT","errorContainer":"CTyHi","errorContent":"_ajiW","settingsContent":"fMwUZ","footer":"LKt_k"};